"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FAIconName;
(function (FAIconName) {
    FAIconName[FAIconName["glass"] = 0] = "glass";
    FAIconName[FAIconName["music"] = 1] = "music";
    FAIconName[FAIconName["search"] = 2] = "search";
    FAIconName[FAIconName["envelopeAlt"] = 3] = "envelopeAlt";
    FAIconName[FAIconName["heart"] = 4] = "heart";
    FAIconName[FAIconName["star"] = 5] = "star";
    FAIconName[FAIconName["starEmpty"] = 6] = "starEmpty";
    FAIconName[FAIconName["user"] = 7] = "user";
    FAIconName[FAIconName["film"] = 8] = "film";
    FAIconName[FAIconName["thLarge"] = 9] = "thLarge";
    FAIconName[FAIconName["th"] = 10] = "th";
    FAIconName[FAIconName["thList"] = 11] = "thList";
    FAIconName[FAIconName["ok"] = 12] = "ok";
    FAIconName[FAIconName["remove"] = 13] = "remove";
    FAIconName[FAIconName["zoomIn"] = 14] = "zoomIn";
    FAIconName[FAIconName["zoomOut"] = 15] = "zoomOut";
    FAIconName[FAIconName["powerOff"] = 16] = "powerOff";
    FAIconName[FAIconName["off"] = 17] = "off";
    FAIconName[FAIconName["signal"] = 18] = "signal";
    FAIconName[FAIconName["gear"] = 19] = "gear";
    FAIconName[FAIconName["cog"] = 20] = "cog";
    FAIconName[FAIconName["trash"] = 21] = "trash";
    FAIconName[FAIconName["home"] = 22] = "home";
    FAIconName[FAIconName["fileAlt"] = 23] = "fileAlt";
    FAIconName[FAIconName["time"] = 24] = "time";
    FAIconName[FAIconName["road"] = 25] = "road";
    FAIconName[FAIconName["downloadAlt"] = 26] = "downloadAlt";
    FAIconName[FAIconName["download"] = 27] = "download";
    FAIconName[FAIconName["upload"] = 28] = "upload";
    FAIconName[FAIconName["inbox"] = 29] = "inbox";
    FAIconName[FAIconName["playCircle"] = 30] = "playCircle";
    FAIconName[FAIconName["rotateRight"] = 31] = "rotateRight";
    FAIconName[FAIconName["repeat"] = 32] = "repeat";
    FAIconName[FAIconName["refresh"] = 33] = "refresh";
    FAIconName[FAIconName["listAlt"] = 34] = "listAlt";
    FAIconName[FAIconName["lock"] = 35] = "lock";
    FAIconName[FAIconName["flag"] = 36] = "flag";
    FAIconName[FAIconName["headphones"] = 37] = "headphones";
    FAIconName[FAIconName["volumeOff"] = 38] = "volumeOff";
    FAIconName[FAIconName["volumeDown"] = 39] = "volumeDown";
    FAIconName[FAIconName["volumeUp"] = 40] = "volumeUp";
    FAIconName[FAIconName["qrcode"] = 41] = "qrcode";
    FAIconName[FAIconName["barcode"] = 42] = "barcode";
    FAIconName[FAIconName["tag"] = 43] = "tag";
    FAIconName[FAIconName["tags"] = 44] = "tags";
    FAIconName[FAIconName["book"] = 45] = "book";
    FAIconName[FAIconName["bookmark"] = 46] = "bookmark";
    FAIconName[FAIconName["print"] = 47] = "print";
    FAIconName[FAIconName["camera"] = 48] = "camera";
    FAIconName[FAIconName["font"] = 49] = "font";
    FAIconName[FAIconName["bold"] = 50] = "bold";
    FAIconName[FAIconName["italic"] = 51] = "italic";
    FAIconName[FAIconName["textHeight"] = 52] = "textHeight";
    FAIconName[FAIconName["textWidth"] = 53] = "textWidth";
    FAIconName[FAIconName["alignLeft"] = 54] = "alignLeft";
    FAIconName[FAIconName["alignCenter"] = 55] = "alignCenter";
    FAIconName[FAIconName["alignRight"] = 56] = "alignRight";
    FAIconName[FAIconName["alignJustify"] = 57] = "alignJustify";
    FAIconName[FAIconName["list"] = 58] = "list";
    FAIconName[FAIconName["indentLeft"] = 59] = "indentLeft";
    FAIconName[FAIconName["indentRight"] = 60] = "indentRight";
    FAIconName[FAIconName["facetimeVideo"] = 61] = "facetimeVideo";
    FAIconName[FAIconName["picture"] = 62] = "picture";
    FAIconName[FAIconName["pencil"] = 63] = "pencil";
    FAIconName[FAIconName["mapMarker"] = 64] = "mapMarker";
    FAIconName[FAIconName["adjust"] = 65] = "adjust";
    FAIconName[FAIconName["tint"] = 66] = "tint";
    FAIconName[FAIconName["edit"] = 67] = "edit";
    FAIconName[FAIconName["share"] = 68] = "share";
    FAIconName[FAIconName["check"] = 69] = "check";
    FAIconName[FAIconName["move"] = 70] = "move";
    FAIconName[FAIconName["stepBackward"] = 71] = "stepBackward";
    FAIconName[FAIconName["fastBackward"] = 72] = "fastBackward";
    FAIconName[FAIconName["backward"] = 73] = "backward";
    FAIconName[FAIconName["play"] = 74] = "play";
    FAIconName[FAIconName["pause"] = 75] = "pause";
    FAIconName[FAIconName["stop"] = 76] = "stop";
    FAIconName[FAIconName["forward"] = 77] = "forward";
    FAIconName[FAIconName["fastForward"] = 78] = "fastForward";
    FAIconName[FAIconName["stepForward"] = 79] = "stepForward";
    FAIconName[FAIconName["eject"] = 80] = "eject";
    FAIconName[FAIconName["chevronLeft"] = 81] = "chevronLeft";
    FAIconName[FAIconName["chevronRight"] = 82] = "chevronRight";
    FAIconName[FAIconName["plusSign"] = 83] = "plusSign";
    FAIconName[FAIconName["minusSign"] = 84] = "minusSign";
    FAIconName[FAIconName["removeSign"] = 85] = "removeSign";
    FAIconName[FAIconName["okSign"] = 86] = "okSign";
    FAIconName[FAIconName["questionSign"] = 87] = "questionSign";
    FAIconName[FAIconName["infoSign"] = 88] = "infoSign";
    FAIconName[FAIconName["screenshot"] = 89] = "screenshot";
    FAIconName[FAIconName["removeCircle"] = 90] = "removeCircle";
    FAIconName[FAIconName["okCircle"] = 91] = "okCircle";
    FAIconName[FAIconName["banCircle"] = 92] = "banCircle";
    FAIconName[FAIconName["arrowLeft"] = 93] = "arrowLeft";
    FAIconName[FAIconName["arrowRight"] = 94] = "arrowRight";
    FAIconName[FAIconName["arrowUp"] = 95] = "arrowUp";
    FAIconName[FAIconName["arrowDown"] = 96] = "arrowDown";
    FAIconName[FAIconName["mailForward"] = 97] = "mailForward";
    FAIconName[FAIconName["shareAlt"] = 98] = "shareAlt";
    FAIconName[FAIconName["resizeFull"] = 99] = "resizeFull";
    FAIconName[FAIconName["resizeSmall"] = 100] = "resizeSmall";
    FAIconName[FAIconName["plus"] = 101] = "plus";
    FAIconName[FAIconName["minus"] = 102] = "minus";
    FAIconName[FAIconName["asterisk"] = 103] = "asterisk";
    FAIconName[FAIconName["exclamationSign"] = 104] = "exclamationSign";
    FAIconName[FAIconName["gift"] = 105] = "gift";
    FAIconName[FAIconName["leaf"] = 106] = "leaf";
    FAIconName[FAIconName["fire"] = 107] = "fire";
    FAIconName[FAIconName["eyeOpen"] = 108] = "eyeOpen";
    FAIconName[FAIconName["eyeClose"] = 109] = "eyeClose";
    FAIconName[FAIconName["warningSign"] = 110] = "warningSign";
    FAIconName[FAIconName["plane"] = 111] = "plane";
    FAIconName[FAIconName["calendar"] = 112] = "calendar";
    FAIconName[FAIconName["random"] = 113] = "random";
    FAIconName[FAIconName["comment"] = 114] = "comment";
    FAIconName[FAIconName["magnet"] = 115] = "magnet";
    FAIconName[FAIconName["chevronUp"] = 116] = "chevronUp";
    FAIconName[FAIconName["chevronDown"] = 117] = "chevronDown";
    FAIconName[FAIconName["retweet"] = 118] = "retweet";
    FAIconName[FAIconName["shoppingCart"] = 119] = "shoppingCart";
    FAIconName[FAIconName["folderClose"] = 120] = "folderClose";
    FAIconName[FAIconName["folderOpen"] = 121] = "folderOpen";
    FAIconName[FAIconName["resizeVertical"] = 122] = "resizeVertical";
    FAIconName[FAIconName["resizeHorizontal"] = 123] = "resizeHorizontal";
    FAIconName[FAIconName["barChart"] = 124] = "barChart";
    FAIconName[FAIconName["twitterSign"] = 125] = "twitterSign";
    FAIconName[FAIconName["facebookSign"] = 126] = "facebookSign";
    FAIconName[FAIconName["cameraRetro"] = 127] = "cameraRetro";
    FAIconName[FAIconName["key"] = 128] = "key";
    FAIconName[FAIconName["gears"] = 129] = "gears";
    FAIconName[FAIconName["cogs"] = 130] = "cogs";
    FAIconName[FAIconName["comments"] = 131] = "comments";
    FAIconName[FAIconName["thumbsUpAlt"] = 132] = "thumbsUpAlt";
    FAIconName[FAIconName["thumbsDownAlt"] = 133] = "thumbsDownAlt";
    FAIconName[FAIconName["starHalf"] = 134] = "starHalf";
    FAIconName[FAIconName["heartEmpty"] = 135] = "heartEmpty";
    FAIconName[FAIconName["signout"] = 136] = "signout";
    FAIconName[FAIconName["linkedinSign"] = 137] = "linkedinSign";
    FAIconName[FAIconName["pushpin"] = 138] = "pushpin";
    FAIconName[FAIconName["externalLink"] = 139] = "externalLink";
    FAIconName[FAIconName["signin"] = 140] = "signin";
    FAIconName[FAIconName["trophy"] = 141] = "trophy";
    FAIconName[FAIconName["githubSign"] = 142] = "githubSign";
    FAIconName[FAIconName["uploadAlt"] = 143] = "uploadAlt";
    FAIconName[FAIconName["lemon"] = 144] = "lemon";
    FAIconName[FAIconName["phone"] = 145] = "phone";
    FAIconName[FAIconName["unchecked"] = 146] = "unchecked";
    FAIconName[FAIconName["checkEmpty"] = 147] = "checkEmpty";
    FAIconName[FAIconName["bookmarkEmpty"] = 148] = "bookmarkEmpty";
    FAIconName[FAIconName["phoneSign"] = 149] = "phoneSign";
    FAIconName[FAIconName["twitter"] = 150] = "twitter";
    FAIconName[FAIconName["facebook"] = 151] = "facebook";
    FAIconName[FAIconName["github"] = 152] = "github";
    FAIconName[FAIconName["unlock"] = 153] = "unlock";
    FAIconName[FAIconName["creditCard"] = 154] = "creditCard";
    FAIconName[FAIconName["rss"] = 155] = "rss";
    FAIconName[FAIconName["hdd"] = 156] = "hdd";
    FAIconName[FAIconName["bullhorn"] = 157] = "bullhorn";
    FAIconName[FAIconName["bell"] = 158] = "bell";
    FAIconName[FAIconName["certificate"] = 159] = "certificate";
    FAIconName[FAIconName["handRight"] = 160] = "handRight";
    FAIconName[FAIconName["handLeft"] = 161] = "handLeft";
    FAIconName[FAIconName["handUp"] = 162] = "handUp";
    FAIconName[FAIconName["handDown"] = 163] = "handDown";
    FAIconName[FAIconName["circleArrowLeft"] = 164] = "circleArrowLeft";
    FAIconName[FAIconName["circleArrowRight"] = 165] = "circleArrowRight";
    FAIconName[FAIconName["circleArrowUp"] = 166] = "circleArrowUp";
    FAIconName[FAIconName["circleArrowDown"] = 167] = "circleArrowDown";
    FAIconName[FAIconName["globe"] = 168] = "globe";
    FAIconName[FAIconName["wrench"] = 169] = "wrench";
    FAIconName[FAIconName["tasks"] = 170] = "tasks";
    FAIconName[FAIconName["filter"] = 171] = "filter";
    FAIconName[FAIconName["briefcase"] = 172] = "briefcase";
    FAIconName[FAIconName["fullscreen"] = 173] = "fullscreen";
    FAIconName[FAIconName["group"] = 174] = "group";
    FAIconName[FAIconName["link"] = 175] = "link";
    FAIconName[FAIconName["cloud"] = 176] = "cloud";
    FAIconName[FAIconName["beaker"] = 177] = "beaker";
    FAIconName[FAIconName["cut"] = 178] = "cut";
    FAIconName[FAIconName["copy"] = 179] = "copy";
    FAIconName[FAIconName["paperclip"] = 180] = "paperclip";
    FAIconName[FAIconName["paperClip"] = 181] = "paperClip";
    FAIconName[FAIconName["save"] = 182] = "save";
    FAIconName[FAIconName["signBlank"] = 183] = "signBlank";
    FAIconName[FAIconName["reorder"] = 184] = "reorder";
    FAIconName[FAIconName["listUl"] = 185] = "listUl";
    FAIconName[FAIconName["listOl"] = 186] = "listOl";
    FAIconName[FAIconName["strikethrough"] = 187] = "strikethrough";
    FAIconName[FAIconName["underline"] = 188] = "underline";
    FAIconName[FAIconName["table"] = 189] = "table";
    FAIconName[FAIconName["magic"] = 190] = "magic";
    FAIconName[FAIconName["truck"] = 191] = "truck";
    FAIconName[FAIconName["pinterest"] = 192] = "pinterest";
    FAIconName[FAIconName["pinterestSign"] = 193] = "pinterestSign";
    FAIconName[FAIconName["googlePlusSign"] = 194] = "googlePlusSign";
    FAIconName[FAIconName["googlePlus"] = 195] = "googlePlus";
    FAIconName[FAIconName["money"] = 196] = "money";
    FAIconName[FAIconName["caretDown"] = 197] = "caretDown";
    FAIconName[FAIconName["caretUp"] = 198] = "caretUp";
    FAIconName[FAIconName["caretLeft"] = 199] = "caretLeft";
    FAIconName[FAIconName["caretRight"] = 200] = "caretRight";
    FAIconName[FAIconName["columns"] = 201] = "columns";
    FAIconName[FAIconName["sort"] = 202] = "sort";
    FAIconName[FAIconName["sortDown"] = 203] = "sortDown";
    FAIconName[FAIconName["sortUp"] = 204] = "sortUp";
    FAIconName[FAIconName["envelope"] = 205] = "envelope";
    FAIconName[FAIconName["linkedin"] = 206] = "linkedin";
    FAIconName[FAIconName["rotateLeft"] = 207] = "rotateLeft";
    FAIconName[FAIconName["undo"] = 208] = "undo";
    FAIconName[FAIconName["legal"] = 209] = "legal";
    FAIconName[FAIconName["dashboard"] = 210] = "dashboard";
    FAIconName[FAIconName["commentAlt"] = 211] = "commentAlt";
    FAIconName[FAIconName["commentsAlt"] = 212] = "commentsAlt";
    FAIconName[FAIconName["bolt"] = 213] = "bolt";
    FAIconName[FAIconName["sitemap"] = 214] = "sitemap";
    FAIconName[FAIconName["umbrella"] = 215] = "umbrella";
    FAIconName[FAIconName["paste"] = 216] = "paste";
    FAIconName[FAIconName["lightbulb"] = 217] = "lightbulb";
    FAIconName[FAIconName["exchange"] = 218] = "exchange";
    FAIconName[FAIconName["cloudDownload"] = 219] = "cloudDownload";
    FAIconName[FAIconName["cloudUpload"] = 220] = "cloudUpload";
    FAIconName[FAIconName["userMd"] = 221] = "userMd";
    FAIconName[FAIconName["stethoscope"] = 222] = "stethoscope";
    FAIconName[FAIconName["suitcase"] = 223] = "suitcase";
    FAIconName[FAIconName["bellAlt"] = 224] = "bellAlt";
    FAIconName[FAIconName["coffee"] = 225] = "coffee";
    FAIconName[FAIconName["food"] = 226] = "food";
    FAIconName[FAIconName["fileTextAlt"] = 227] = "fileTextAlt";
    FAIconName[FAIconName["building"] = 228] = "building";
    FAIconName[FAIconName["hospital"] = 229] = "hospital";
    FAIconName[FAIconName["ambulance"] = 230] = "ambulance";
    FAIconName[FAIconName["medkit"] = 231] = "medkit";
    FAIconName[FAIconName["fighterJet"] = 232] = "fighterJet";
    FAIconName[FAIconName["beer"] = 233] = "beer";
    FAIconName[FAIconName["hSign"] = 234] = "hSign";
    FAIconName[FAIconName["plusSignAlt"] = 235] = "plusSignAlt";
    FAIconName[FAIconName["doubleAngleLeft"] = 236] = "doubleAngleLeft";
    FAIconName[FAIconName["doubleAngleRight"] = 237] = "doubleAngleRight";
    FAIconName[FAIconName["doubleAngleUp"] = 238] = "doubleAngleUp";
    FAIconName[FAIconName["doubleAngleDown"] = 239] = "doubleAngleDown";
    FAIconName[FAIconName["angleLeft"] = 240] = "angleLeft";
    FAIconName[FAIconName["angleRight"] = 241] = "angleRight";
    FAIconName[FAIconName["angleUp"] = 242] = "angleUp";
    FAIconName[FAIconName["angleDown"] = 243] = "angleDown";
    FAIconName[FAIconName["desktop"] = 244] = "desktop";
    FAIconName[FAIconName["laptop"] = 245] = "laptop";
    FAIconName[FAIconName["tablet"] = 246] = "tablet";
    FAIconName[FAIconName["mobilePhone"] = 247] = "mobilePhone";
    FAIconName[FAIconName["circleBlank"] = 248] = "circleBlank";
    FAIconName[FAIconName["quoteLeft"] = 249] = "quoteLeft";
    FAIconName[FAIconName["quoteRight"] = 250] = "quoteRight";
    FAIconName[FAIconName["spinner"] = 251] = "spinner";
    FAIconName[FAIconName["circle"] = 252] = "circle";
    FAIconName[FAIconName["mailReply"] = 253] = "mailReply";
    FAIconName[FAIconName["reply"] = 254] = "reply";
    FAIconName[FAIconName["githubAlt"] = 255] = "githubAlt";
    FAIconName[FAIconName["folderCloseAlt"] = 256] = "folderCloseAlt";
    FAIconName[FAIconName["folderOpenAlt"] = 257] = "folderOpenAlt";
    FAIconName[FAIconName["expandAlt"] = 258] = "expandAlt";
    FAIconName[FAIconName["collapseAlt"] = 259] = "collapseAlt";
    FAIconName[FAIconName["smile"] = 260] = "smile";
    FAIconName[FAIconName["frown"] = 261] = "frown";
    FAIconName[FAIconName["meh"] = 262] = "meh";
    FAIconName[FAIconName["gamepad"] = 263] = "gamepad";
    FAIconName[FAIconName["keyboard"] = 264] = "keyboard";
    FAIconName[FAIconName["flagAlt"] = 265] = "flagAlt";
    FAIconName[FAIconName["flagCheckered"] = 266] = "flagCheckered";
    FAIconName[FAIconName["terminal"] = 267] = "terminal";
    FAIconName[FAIconName["code"] = 268] = "code";
    FAIconName[FAIconName["replyAll"] = 269] = "replyAll";
    FAIconName[FAIconName["mailReplyAll"] = 270] = "mailReplyAll";
    FAIconName[FAIconName["starHalfFull"] = 271] = "starHalfFull";
    FAIconName[FAIconName["starHalfEmpty"] = 272] = "starHalfEmpty";
    FAIconName[FAIconName["locationArrow"] = 273] = "locationArrow";
    FAIconName[FAIconName["crop"] = 274] = "crop";
    FAIconName[FAIconName["codeFork"] = 275] = "codeFork";
    FAIconName[FAIconName["unlink"] = 276] = "unlink";
    FAIconName[FAIconName["question"] = 277] = "question";
    FAIconName[FAIconName["info"] = 278] = "info";
    FAIconName[FAIconName["exclamation"] = 279] = "exclamation";
    FAIconName[FAIconName["superscript"] = 280] = "superscript";
    FAIconName[FAIconName["subscript"] = 281] = "subscript";
    FAIconName[FAIconName["eraser"] = 282] = "eraser";
    FAIconName[FAIconName["puzzlePiece"] = 283] = "puzzlePiece";
    FAIconName[FAIconName["microphone"] = 284] = "microphone";
    FAIconName[FAIconName["microphoneOff"] = 285] = "microphoneOff";
    FAIconName[FAIconName["shield"] = 286] = "shield";
    FAIconName[FAIconName["calendarEmpty"] = 287] = "calendarEmpty";
    FAIconName[FAIconName["fireExtinguisher"] = 288] = "fireExtinguisher";
    FAIconName[FAIconName["rocket"] = 289] = "rocket";
    FAIconName[FAIconName["maxcdn"] = 290] = "maxcdn";
    FAIconName[FAIconName["chevronSignLeft"] = 291] = "chevronSignLeft";
    FAIconName[FAIconName["chevronSignRight"] = 292] = "chevronSignRight";
    FAIconName[FAIconName["chevronSignUp"] = 293] = "chevronSignUp";
    FAIconName[FAIconName["chevronSignDown"] = 294] = "chevronSignDown";
    FAIconName[FAIconName["html5"] = 295] = "html5";
    FAIconName[FAIconName["css3"] = 296] = "css3";
    FAIconName[FAIconName["anchor"] = 297] = "anchor";
    FAIconName[FAIconName["unlockAlt"] = 298] = "unlockAlt";
    FAIconName[FAIconName["bullseye"] = 299] = "bullseye";
    FAIconName[FAIconName["ellipsisHorizontal"] = 300] = "ellipsisHorizontal";
    FAIconName[FAIconName["ellipsisVertical"] = 301] = "ellipsisVertical";
    FAIconName[FAIconName["rssSign"] = 302] = "rssSign";
    FAIconName[FAIconName["playSign"] = 303] = "playSign";
    FAIconName[FAIconName["ticket"] = 304] = "ticket";
    FAIconName[FAIconName["minusSignAlt"] = 305] = "minusSignAlt";
    FAIconName[FAIconName["checkMinus"] = 306] = "checkMinus";
    FAIconName[FAIconName["levelUp"] = 307] = "levelUp";
    FAIconName[FAIconName["levelDown"] = 308] = "levelDown";
    FAIconName[FAIconName["checkSign"] = 309] = "checkSign";
    FAIconName[FAIconName["editSign"] = 310] = "editSign";
    FAIconName[FAIconName["externalLinkSign"] = 311] = "externalLinkSign";
    FAIconName[FAIconName["shareSign"] = 312] = "shareSign";
    FAIconName[FAIconName["compass"] = 313] = "compass";
    FAIconName[FAIconName["collapse"] = 314] = "collapse";
    FAIconName[FAIconName["collapseTop"] = 315] = "collapseTop";
    FAIconName[FAIconName["expand"] = 316] = "expand";
    FAIconName[FAIconName["euro"] = 317] = "euro";
    FAIconName[FAIconName["eur"] = 318] = "eur";
    FAIconName[FAIconName["gbp"] = 319] = "gbp";
    FAIconName[FAIconName["dollar"] = 320] = "dollar";
    FAIconName[FAIconName["usd"] = 321] = "usd";
    FAIconName[FAIconName["rupee"] = 322] = "rupee";
    FAIconName[FAIconName["inr"] = 323] = "inr";
    FAIconName[FAIconName["yen"] = 324] = "yen";
    FAIconName[FAIconName["jpy"] = 325] = "jpy";
    FAIconName[FAIconName["renminbi"] = 326] = "renminbi";
    FAIconName[FAIconName["cny"] = 327] = "cny";
    FAIconName[FAIconName["won"] = 328] = "won";
    FAIconName[FAIconName["krw"] = 329] = "krw";
    FAIconName[FAIconName["bitcoin"] = 330] = "bitcoin";
    FAIconName[FAIconName["btc"] = 331] = "btc";
    FAIconName[FAIconName["file"] = 332] = "file";
    FAIconName[FAIconName["fileText"] = 333] = "fileText";
    FAIconName[FAIconName["sortByAlphabet"] = 334] = "sortByAlphabet";
    FAIconName[FAIconName["sortByAlphabetAlt"] = 335] = "sortByAlphabetAlt";
    FAIconName[FAIconName["sortByAttributes"] = 336] = "sortByAttributes";
    FAIconName[FAIconName["sortByAttributesAlt"] = 337] = "sortByAttributesAlt";
    FAIconName[FAIconName["sortByOrder"] = 338] = "sortByOrder";
    FAIconName[FAIconName["sortByOrderAlt"] = 339] = "sortByOrderAlt";
    FAIconName[FAIconName["thumbsUp"] = 340] = "thumbsUp";
    FAIconName[FAIconName["thumbsDown"] = 341] = "thumbsDown";
    FAIconName[FAIconName["youtubeSign"] = 342] = "youtubeSign";
    FAIconName[FAIconName["youtube"] = 343] = "youtube";
    FAIconName[FAIconName["xing"] = 344] = "xing";
    FAIconName[FAIconName["xingSign"] = 345] = "xingSign";
    FAIconName[FAIconName["youtubePlay"] = 346] = "youtubePlay";
    FAIconName[FAIconName["dropbox"] = 347] = "dropbox";
    FAIconName[FAIconName["stackexchange"] = 348] = "stackexchange";
    FAIconName[FAIconName["instagram"] = 349] = "instagram";
    FAIconName[FAIconName["flickr"] = 350] = "flickr";
    FAIconName[FAIconName["adn"] = 351] = "adn";
    FAIconName[FAIconName["bitbucket"] = 352] = "bitbucket";
    FAIconName[FAIconName["bitbucketSign"] = 353] = "bitbucketSign";
    FAIconName[FAIconName["tumblr"] = 354] = "tumblr";
    FAIconName[FAIconName["tumblrSign"] = 355] = "tumblrSign";
    FAIconName[FAIconName["longArrowDown"] = 356] = "longArrowDown";
    FAIconName[FAIconName["longArrowUp"] = 357] = "longArrowUp";
    FAIconName[FAIconName["longArrowLeft"] = 358] = "longArrowLeft";
    FAIconName[FAIconName["longArrowRight"] = 359] = "longArrowRight";
    FAIconName[FAIconName["apple"] = 360] = "apple";
    FAIconName[FAIconName["windows"] = 361] = "windows";
    FAIconName[FAIconName["android"] = 362] = "android";
    FAIconName[FAIconName["linux"] = 363] = "linux";
    FAIconName[FAIconName["dribbble"] = 364] = "dribbble";
    FAIconName[FAIconName["skype"] = 365] = "skype";
    FAIconName[FAIconName["foursquare"] = 366] = "foursquare";
    FAIconName[FAIconName["trello"] = 367] = "trello";
    FAIconName[FAIconName["female"] = 368] = "female";
    FAIconName[FAIconName["male"] = 369] = "male";
    FAIconName[FAIconName["gittip"] = 370] = "gittip";
    FAIconName[FAIconName["sun"] = 371] = "sun";
    FAIconName[FAIconName["moon"] = 372] = "moon";
    FAIconName[FAIconName["archive"] = 373] = "archive";
    FAIconName[FAIconName["bug"] = 374] = "bug";
    FAIconName[FAIconName["vk"] = 375] = "vk";
    FAIconName[FAIconName["weibo"] = 376] = "weibo";
    FAIconName[FAIconName["renren"] = 377] = "renren";
    FAIconName[FAIconName["copyright"] = 378] = "copyright";
    FAIconName[FAIconName["at"] = 379] = "at";
    FAIconName[FAIconName["infoCircle"] = 380] = "infoCircle";
})(FAIconName = exports.FAIconName || (exports.FAIconName = {}));
function toFontAwesomeCharCode(iconName) {
    switch (iconName) {
        case FAIconName.glass: return "\uf000";
        case FAIconName.music: return "\uf001";
        case FAIconName.search: return "\uf002";
        case FAIconName.envelopeAlt: return "\uf003";
        case FAIconName.heart: return "\uf004";
        case FAIconName.star: return "\uf005";
        case FAIconName.starEmpty: return "\uf006";
        case FAIconName.user: return "\uf007";
        case FAIconName.film: return "\uf008";
        case FAIconName.thLarge: return "\uf009";
        case FAIconName.th: return "\uf00a";
        case FAIconName.thList: return "\uf00b";
        case FAIconName.ok: return "\uf00c";
        case FAIconName.remove: return "\uf00d";
        case FAIconName.zoomIn: return "\uf00e";
        case FAIconName.zoomOut: return "\uf010";
        case FAIconName.powerOff:
        case FAIconName.off: return "\uf011";
        case FAIconName.signal: return "\uf012";
        case FAIconName.gear:
        case FAIconName.cog: return "\uf013";
        case FAIconName.trash: return "\uf014";
        case FAIconName.home: return "\uf015";
        case FAIconName.fileAlt: return "\uf016";
        case FAIconName.time: return "\uf017";
        case FAIconName.road: return "\uf018";
        case FAIconName.downloadAlt: return "\uf019";
        case FAIconName.download: return "\uf01a";
        case FAIconName.upload: return "\uf01b";
        case FAIconName.inbox: return "\uf01c";
        case FAIconName.playCircle: return "\uf01d";
        case FAIconName.rotateRight:
        case FAIconName.repeat: return "\uf01e";
        case FAIconName.refresh: return "\uf021";
        case FAIconName.listAlt: return "\uf022";
        case FAIconName.lock: return "\uf023";
        case FAIconName.flag: return "\uf024";
        case FAIconName.headphones: return "\uf025";
        case FAIconName.volumeOff: return "\uf026";
        case FAIconName.volumeDown: return "\uf027";
        case FAIconName.volumeUp: return "\uf028";
        case FAIconName.qrcode: return "\uf029";
        case FAIconName.barcode: return "\uf02a";
        case FAIconName.tag: return "\uf02b";
        case FAIconName.tags: return "\uf02c";
        case FAIconName.book: return "\uf02d";
        case FAIconName.bookmark: return "\uf02e";
        case FAIconName.print: return "\uf02f";
        case FAIconName.camera: return "\uf030";
        case FAIconName.font: return "\uf031";
        case FAIconName.bold: return "\uf032";
        case FAIconName.italic: return "\uf033";
        case FAIconName.textHeight: return "\uf034";
        case FAIconName.textWidth: return "\uf035";
        case FAIconName.alignLeft: return "\uf036";
        case FAIconName.alignCenter: return "\uf037";
        case FAIconName.alignRight: return "\uf038";
        case FAIconName.alignJustify: return "\uf039";
        case FAIconName.list: return "\uf03a";
        case FAIconName.indentLeft: return "\uf03b";
        case FAIconName.indentRight: return "\uf03c";
        case FAIconName.facetimeVideo: return "\uf03d";
        case FAIconName.picture: return "\uf03e";
        case FAIconName.pencil: return "\uf040";
        case FAIconName.mapMarker: return "\uf041";
        case FAIconName.adjust: return "\uf042";
        case FAIconName.tint: return "\uf043";
        case FAIconName.edit: return "\uf044";
        case FAIconName.share: return "\uf045";
        case FAIconName.check: return "\uf046";
        case FAIconName.move: return "\uf047";
        case FAIconName.stepBackward: return "\uf048";
        case FAIconName.fastBackward: return "\uf049";
        case FAIconName.backward: return "\uf04a";
        case FAIconName.play: return "\uf04b";
        case FAIconName.pause: return "\uf04c";
        case FAIconName.stop: return "\uf04d";
        case FAIconName.forward: return "\uf04e";
        case FAIconName.fastForward: return "\uf050";
        case FAIconName.stepForward: return "\uf051";
        case FAIconName.eject: return "\uf052";
        case FAIconName.chevronLeft: return "\uf053";
        case FAIconName.chevronRight: return "\uf054";
        case FAIconName.plusSign: return "\uf055";
        case FAIconName.minusSign: return "\uf056";
        case FAIconName.removeSign: return "\uf057";
        case FAIconName.okSign: return "\uf058";
        case FAIconName.questionSign: return "\uf059";
        case FAIconName.infoSign: return "\uf05a";
        case FAIconName.screenshot: return "\uf05b";
        case FAIconName.removeCircle: return "\uf05c";
        case FAIconName.okCircle: return "\uf05d";
        case FAIconName.banCircle: return "\uf05e";
        case FAIconName.arrowLeft: return "\uf060";
        case FAIconName.arrowRight: return "\uf061";
        case FAIconName.arrowUp: return "\uf062";
        case FAIconName.arrowDown: return "\uf063";
        case FAIconName.mailForward:
        case FAIconName.shareAlt: return "\uf064";
        case FAIconName.resizeFull: return "\uf065";
        case FAIconName.resizeSmall: return "\uf066";
        case FAIconName.plus: return "\uf067";
        case FAIconName.minus: return "\uf068";
        case FAIconName.asterisk: return "\uf069";
        case FAIconName.exclamationSign: return "\uf06a";
        case FAIconName.gift: return "\uf06b";
        case FAIconName.leaf: return "\uf06c";
        case FAIconName.fire: return "\uf06d";
        case FAIconName.eyeOpen: return "\uf06e";
        case FAIconName.eyeClose: return "\uf070";
        case FAIconName.warningSign: return "\uf071";
        case FAIconName.plane: return "\uf072";
        case FAIconName.calendar: return "\uf073";
        case FAIconName.random: return "\uf074";
        case FAIconName.comment: return "\uf075";
        case FAIconName.magnet: return "\uf076";
        case FAIconName.chevronUp: return "\uf077";
        case FAIconName.chevronDown: return "\uf078";
        case FAIconName.retweet: return "\uf079";
        case FAIconName.shoppingCart: return "\uf07a";
        case FAIconName.folderClose: return "\uf07b";
        case FAIconName.folderOpen: return "\uf07c";
        case FAIconName.resizeVertical: return "\uf07d";
        case FAIconName.resizeHorizontal: return "\uf07e";
        case FAIconName.barChart: return "\uf080";
        case FAIconName.twitterSign: return "\uf081";
        case FAIconName.facebookSign: return "\uf082";
        case FAIconName.cameraRetro: return "\uf083";
        case FAIconName.key: return "\uf084";
        case FAIconName.gears:
        case FAIconName.cogs: return "\uf085";
        case FAIconName.comments: return "\uf086";
        case FAIconName.thumbsUpAlt: return "\uf087";
        case FAIconName.thumbsDownAlt: return "\uf088";
        case FAIconName.starHalf: return "\uf089";
        case FAIconName.heartEmpty: return "\uf08a";
        case FAIconName.signout: return "\uf08b";
        case FAIconName.linkedinSign: return "\uf08c";
        case FAIconName.pushpin: return "\uf08d";
        case FAIconName.externalLink: return "\uf08e";
        case FAIconName.signin: return "\uf090";
        case FAIconName.trophy: return "\uf091";
        case FAIconName.githubSign: return "\uf092";
        case FAIconName.uploadAlt: return "\uf093";
        case FAIconName.lemon: return "\uf094";
        case FAIconName.phone: return "\uf095";
        case FAIconName.unchecked:
        case FAIconName.checkEmpty: return "\uf096";
        case FAIconName.bookmarkEmpty: return "\uf097";
        case FAIconName.phoneSign: return "\uf098";
        case FAIconName.twitter: return "\uf099";
        case FAIconName.facebook: return "\uf09a";
        case FAIconName.github: return "\uf09b";
        case FAIconName.unlock: return "\uf09c";
        case FAIconName.creditCard: return "\uf09d";
        case FAIconName.rss: return "\uf09e";
        case FAIconName.hdd: return "\uf0a0";
        case FAIconName.bullhorn: return "\uf0a1";
        case FAIconName.bell: return "\uf0a2";
        case FAIconName.certificate: return "\uf0a3";
        case FAIconName.handRight: return "\uf0a4";
        case FAIconName.handLeft: return "\uf0a5";
        case FAIconName.handUp: return "\uf0a6";
        case FAIconName.handDown: return "\uf0a7";
        case FAIconName.circleArrowLeft: return "\uf0a8";
        case FAIconName.circleArrowRight: return "\uf0a9";
        case FAIconName.circleArrowUp: return "\uf0aa";
        case FAIconName.circleArrowDown: return "\uf0ab";
        case FAIconName.globe: return "\uf0ac";
        case FAIconName.wrench: return "\uf0ad";
        case FAIconName.tasks: return "\uf0ae";
        case FAIconName.filter: return "\uf0b0";
        case FAIconName.briefcase: return "\uf0b1";
        case FAIconName.fullscreen: return "\uf0b2";
        case FAIconName.group: return "\uf0c0";
        case FAIconName.link: return "\uf0c1";
        case FAIconName.cloud: return "\uf0c2";
        case FAIconName.beaker: return "\uf0c3";
        case FAIconName.cut: return "\uf0c4";
        case FAIconName.copy: return "\uf0c5";
        case FAIconName.paperclip:
        case FAIconName.paperClip: return "\uf0c6";
        case FAIconName.save: return "\uf0c7";
        case FAIconName.signBlank: return "\uf0c8";
        case FAIconName.reorder: return "\uf0c9";
        case FAIconName.listUl: return "\uf0ca";
        case FAIconName.listOl: return "\uf0cb";
        case FAIconName.strikethrough: return "\uf0cc";
        case FAIconName.underline: return "\uf0cd";
        case FAIconName.table: return "\uf0ce";
        case FAIconName.magic: return "\uf0d0";
        case FAIconName.truck: return "\uf0d1";
        case FAIconName.pinterest: return "\uf0d2";
        case FAIconName.pinterestSign: return "\uf0d3";
        case FAIconName.googlePlusSign: return "\uf0d4";
        case FAIconName.googlePlus: return "\uf0d5";
        case FAIconName.money: return "\uf0d6";
        case FAIconName.caretDown: return "\uf0d7";
        case FAIconName.caretUp: return "\uf0d8";
        case FAIconName.caretLeft: return "\uf0d9";
        case FAIconName.caretRight: return "\uf0da";
        case FAIconName.columns: return "\uf0db";
        case FAIconName.sort: return "\uf0dc";
        case FAIconName.sortDown: return "\uf0dd";
        case FAIconName.sortUp: return "\uf0de";
        case FAIconName.envelope: return "\uf0e0";
        case FAIconName.linkedin: return "\uf0e1";
        case FAIconName.rotateLeft:
        case FAIconName.undo: return "\uf0e2";
        case FAIconName.legal: return "\uf0e3";
        case FAIconName.dashboard: return "\uf0e4";
        case FAIconName.commentAlt: return "\uf0e5";
        case FAIconName.commentsAlt: return "\uf0e6";
        case FAIconName.bolt: return "\uf0e7";
        case FAIconName.sitemap: return "\uf0e8";
        case FAIconName.umbrella: return "\uf0e9";
        case FAIconName.paste: return "\uf0ea";
        case FAIconName.lightbulb: return "\uf0eb";
        case FAIconName.exchange: return "\uf0ec";
        case FAIconName.cloudDownload: return "\uf0ed";
        case FAIconName.cloudUpload: return "\uf0ee";
        case FAIconName.userMd: return "\uf0f0";
        case FAIconName.stethoscope: return "\uf0f1";
        case FAIconName.suitcase: return "\uf0f2";
        case FAIconName.bellAlt: return "\uf0f3";
        case FAIconName.coffee: return "\uf0f4";
        case FAIconName.food: return "\uf0f5";
        case FAIconName.fileTextAlt: return "\uf0f6";
        case FAIconName.building: return "\uf0f7";
        case FAIconName.hospital: return "\uf0f8";
        case FAIconName.ambulance: return "\uf0f9";
        case FAIconName.medkit: return "\uf0fa";
        case FAIconName.fighterJet: return "\uf0fb";
        case FAIconName.beer: return "\uf0fc";
        case FAIconName.hSign: return "\uf0fd";
        case FAIconName.plusSignAlt: return "\uf0fe";
        case FAIconName.doubleAngleLeft: return "\uf100";
        case FAIconName.doubleAngleRight: return "\uf101";
        case FAIconName.doubleAngleUp: return "\uf102";
        case FAIconName.doubleAngleDown: return "\uf103";
        case FAIconName.angleLeft: return "\uf104";
        case FAIconName.angleRight: return "\uf105";
        case FAIconName.angleUp: return "\uf106";
        case FAIconName.angleDown: return "\uf107";
        case FAIconName.desktop: return "\uf108";
        case FAIconName.laptop: return "\uf109";
        case FAIconName.tablet: return "\uf10a";
        case FAIconName.mobilePhone: return "\uf10b";
        case FAIconName.circleBlank: return "\uf10c";
        case FAIconName.quoteLeft: return "\uf10d";
        case FAIconName.quoteRight: return "\uf10e";
        case FAIconName.spinner: return "\uf110";
        case FAIconName.circle: return "\uf111";
        case FAIconName.mailReply:
        case FAIconName.reply: return "\uf112";
        case FAIconName.githubAlt: return "\uf113";
        case FAIconName.folderCloseAlt: return "\uf114";
        case FAIconName.folderOpenAlt: return "\uf115";
        case FAIconName.expandAlt: return "\uf116";
        case FAIconName.collapseAlt: return "\uf117";
        case FAIconName.smile: return "\uf118";
        case FAIconName.frown: return "\uf119";
        case FAIconName.meh: return "\uf11a";
        case FAIconName.gamepad: return "\uf11b";
        case FAIconName.keyboard: return "\uf11c";
        case FAIconName.flagAlt: return "\uf11d";
        case FAIconName.flagCheckered: return "\uf11e";
        case FAIconName.terminal: return "\uf120";
        case FAIconName.code: return "\uf121";
        case FAIconName.replyAll: return "\uf122";
        case FAIconName.mailReplyAll: return "\uf122";
        case FAIconName.starHalfFull:
        case FAIconName.starHalfEmpty: return "\uf123";
        case FAIconName.locationArrow: return "\uf124";
        case FAIconName.crop: return "\uf125";
        case FAIconName.codeFork: return "\uf126";
        case FAIconName.unlink: return "\uf127";
        case FAIconName.question: return "\uf128";
        case FAIconName.info: return "\uf129";
        case FAIconName.exclamation: return "\uf12a";
        case FAIconName.superscript: return "\uf12b";
        case FAIconName.subscript: return "\uf12c";
        case FAIconName.eraser: return "\uf12d";
        case FAIconName.puzzlePiece: return "\uf12e";
        case FAIconName.microphone: return "\uf130";
        case FAIconName.microphoneOff: return "\uf131";
        case FAIconName.shield: return "\uf132";
        case FAIconName.calendarEmpty: return "\uf133";
        case FAIconName.fireExtinguisher: return "\uf134";
        case FAIconName.rocket: return "\uf135";
        case FAIconName.maxcdn: return "\uf136";
        case FAIconName.chevronSignLeft: return "\uf137";
        case FAIconName.chevronSignRight: return "\uf138";
        case FAIconName.chevronSignUp: return "\uf139";
        case FAIconName.chevronSignDown: return "\uf13a";
        case FAIconName.html5: return "\uf13b";
        case FAIconName.css3: return "\uf13c";
        case FAIconName.anchor: return "\uf13d";
        case FAIconName.unlockAlt: return "\uf13e";
        case FAIconName.bullseye: return "\uf140";
        case FAIconName.ellipsisHorizontal: return "\uf141";
        case FAIconName.ellipsisVertical: return "\uf142";
        case FAIconName.rssSign: return "\uf143";
        case FAIconName.playSign: return "\uf144";
        case FAIconName.ticket: return "\uf145";
        case FAIconName.minusSignAlt: return "\uf146";
        case FAIconName.checkMinus: return "\uf147";
        case FAIconName.levelUp: return "\uf148";
        case FAIconName.levelDown: return "\uf149";
        case FAIconName.checkSign: return "\uf14a";
        case FAIconName.editSign: return "\uf14b";
        case FAIconName.externalLinkSign: return "\uf14c";
        case FAIconName.shareSign: return "\uf14d";
        case FAIconName.compass: return "\uf14e";
        case FAIconName.collapse: return "\uf150";
        case FAIconName.collapseTop: return "\uf151";
        case FAIconName.expand: return "\uf152";
        case FAIconName.euro:
        case FAIconName.eur: return "\uf153";
        case FAIconName.gbp: return "\uf154";
        case FAIconName.dollar:
        case FAIconName.usd: return "\uf155";
        case FAIconName.rupee:
        case FAIconName.inr: return "\uf156";
        case FAIconName.yen:
        case FAIconName.jpy: return "\uf157";
        case FAIconName.renminbi:
        case FAIconName.cny: return "\uf158";
        case FAIconName.won:
        case FAIconName.krw: return "\uf159";
        case FAIconName.bitcoin:
        case FAIconName.btc: return "\uf15a";
        case FAIconName.file: return "\uf15b";
        case FAIconName.fileText: return "\uf15c";
        case FAIconName.sortByAlphabet: return "\uf15d";
        case FAIconName.sortByAlphabetAlt: return "\uf15e";
        case FAIconName.sortByAttributes: return "\uf160";
        case FAIconName.sortByAttributesAlt: return "\uf161";
        case FAIconName.sortByOrder: return "\uf162";
        case FAIconName.sortByOrderAlt: return "\uf163";
        case FAIconName.thumbsUp: return "\uf164";
        case FAIconName.thumbsDown: return "\uf165";
        case FAIconName.youtubeSign: return "\uf166";
        case FAIconName.youtube: return "\uf167";
        case FAIconName.xing: return "\uf168";
        case FAIconName.xingSign: return "\uf169";
        case FAIconName.youtubePlay: return "\uf16a";
        case FAIconName.dropbox: return "\uf16b";
        case FAIconName.stackexchange: return "\uf16c";
        case FAIconName.instagram: return "\uf16d";
        case FAIconName.flickr: return "\uf16e";
        case FAIconName.adn: return "\uf170";
        case FAIconName.bitbucket: return "\uf171";
        case FAIconName.bitbucketSign: return "\uf172";
        case FAIconName.tumblr: return "\uf173";
        case FAIconName.tumblrSign: return "\uf174";
        case FAIconName.longArrowDown: return "\uf175";
        case FAIconName.longArrowUp: return "\uf176";
        case FAIconName.longArrowLeft: return "\uf177";
        case FAIconName.longArrowRight: return "\uf178";
        case FAIconName.apple: return "\uf179";
        case FAIconName.windows: return "\uf17a";
        case FAIconName.android: return "\uf17b";
        case FAIconName.linux: return "\uf17c";
        case FAIconName.dribbble: return "\uf17d";
        case FAIconName.skype: return "\uf17e";
        case FAIconName.foursquare: return "\uf180";
        case FAIconName.trello: return "\uf181";
        case FAIconName.female: return "\uf182";
        case FAIconName.male: return "\uf183";
        case FAIconName.gittip: return "\uf184";
        case FAIconName.sun: return "\uf185";
        case FAIconName.moon: return "\uf186";
        case FAIconName.archive: return "\uf187";
        case FAIconName.bug: return "\uf188";
        case FAIconName.vk: return "\uf189";
        case FAIconName.weibo: return "\uf18a";
        case FAIconName.renren: return "\uf18b";
        case FAIconName.copyright: return "\uf1f9";
        case FAIconName.at: return "\uf1fa";
        case FAIconName.infoCircle: return '\uf05a';
    }
}
exports.toFontAwesomeCharCode = toFontAwesomeCharCode;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/utils/fontAwesomeToCharCode.js
 ** module id = 467
 ** module chunks = 0
 **/